export const TkCargoUrls = {
  BASE: "https://www.turkishcargo.com",
  TRACKING: "/kargo-takip",
};

/**
 * Endpoints excluded from the inactive-customer write block.
 * Add any endpoint fragment here to allow it through even when isActive === false.
 */
export const InactiveCustomerAllowedEndpoints: string[] = ["updatecustomeruserbyregisterid"];
